export default "__VITE_ASSET__C$ZkvbcB__"